/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';


export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'home',
        title: 'หน้าหลัก',
        type: 'basic',
        icon: 'home',
        link: '/home',
        roles: ['SuperAdmin', 'Admin', 'LineManager', 'User', 'Assessor'],
    },
    {
        id: 'myrelatedlaw',
        title: 'My Related Law',
        type: 'basic',
        icon: 'badge',
        link: '/my-related-law',
        roles: ['Assessor', 'Admin'],  // Allow both Assessor and Admin to access law assessment
    },
    {
        id: 'myresponsibililty',
        title: 'รายการที่ได้รับมอบหมาย (ใบอนุญาต/Practice)',
        type: 'basic',
        icon: 'badge',
        link: '/my-responsibility',
        roles: ['SuperAdmin', 'Admin', 'LineManager', 'User', 'Assessor'],
    },
    {
        id: 'extendcertificate',
        title: 'จัดทำแผนดำเนินการ ใบอนุญาต/รายการที่ต้องดำเนินการตามกฎหมาย',
        type: 'basic',
        icon: 'assignment',
        link: '/extend-certificate',
        roles: ['SuperAdmin', 'Admin', 'LineManager', 'User', 'Assessor'],
    },
    {
        id: 'approvalplan',
        title: 'Approval Plan',
        type: 'basic',
        icon: 'inventory',
        link: '/approval-plan',
        roles: ['SuperAdmin', 'Admin', 'LineManager'],
    },
    {
        id: 'updateprogress',
        title: 'รายงานความคืบหน้า',
        type: 'basic',
        icon: 'checklist',
        link: '/update-progress',
        roles: ['SuperAdmin', 'Admin', 'LineManager', 'User', 'Assessor'],
    },
    {
        id: 'reviewplan',
        title: 'Review Plan',
        type: 'basic',
        icon: 'preview',
        link: '/review-plan',
        roles: ['SuperAdmin', 'Admin'],
    },
    {
        id: 'search',
        title: 'ค้นหา',
        icon: 'plagiarism',
        type: 'collapsable',
        children: [
            {
                id: 'related.view-law-regulation',
                title: 'View Law&Regulations',
                type: 'basic',
                icon: 'archive',
                link: '/search/view-law-regulation',
                roles: ['SuperAdmin', 'Admin', 'LineManager', 'User', 'Assessor'],
            },
            {
                id: 'related.view-certificate',
                title: 'View Certificate & Practice',
                type: 'basic',
                icon: 'card_membership',
                link: '/search/view-certificate',
                roles: ['SuperAdmin', 'Admin', 'LineManager', 'User', 'Assessor'],
            },
            {
                id: 'related.view-responsibility-person',
                title: 'View Responsibility Person',
                type: 'basic',
                icon: 'person_search',
                link: '/search/view-responsibility-person',
                roles: ['SuperAdmin', 'Admin', 'LineManager', 'User', 'Assessor'],
            }
        ]
    },
    {
        id: 'news-activity',
        title: 'ข่าว และกิจกรรม',
        type: 'basic',
        icon: 'campaign',
        link: '/news-activity',
        roles: ['SuperAdmin', 'Admin', 'LineManager', 'User', 'Assessor'],
    },
    {
        id: 'about-us',
        title: 'เกี่ยวกับเรา',
        type: 'basic',
        icon: 'groups',
        link: '/about-us',
        roles: ['SuperAdmin', 'Admin', 'LineManager', 'User', 'Assessor'],
    },
    {
        id: 'report',
        title: 'รายงาน',
        icon: 'equalizer',
        link: '/report',
        roles: ['SuperAdmin', 'Admin', 'LineManager', 'User', 'Assessor'],
        type: 'collapsable',
        children: [
            {
                id: 'report.summary-report',
                title: 'รายงานความสอดคล้อง',
                type: 'basic',
                icon: 'equalizer',
                link: '/report/summary-report',
                roles: ['SuperAdmin', 'Admin', 'LineManager', 'User', 'Assessor'],
            },
            {
                id: 'report.law-assessment-report',
                title: 'รายงานการประเมินกฎหมายประจำปี',
                type: 'basic',
                icon: 'equalizer',
                link: '/report/law-assessment-report',
                roles: ['SuperAdmin', 'Admin', 'LineManager', 'User', 'Assessor'],
            },
            {
                id: 'report.law-enforcement-report',
                title: 'รายงานทะเบียนกฎหมาย',
                type: 'basic',
                icon: 'equalizer',
                link: '/report/law-enforcement-report',
                roles: ['SuperAdmin', 'Admin', 'LineManager', 'User', 'Assessor'],
            },
            {
                id: 'report.law-registration-report',
                title: 'รายงานทะเบียนกฎหมายรายปี',
                type: 'basic',
                icon: 'equalizer',
                link: '/report/law-registration-report',
                roles: ['SuperAdmin', 'Admin', 'LineManager', 'User', 'Assessor'],
            }
        ]
    },
    {
        id: 'administrator',
        title: 'Administrator',
        type: 'collapsable',
        icon: 'settings',
        roles: ['SuperAdmin', 'Admin'],
        children: [
            {
                id: 'administrator.manage-law-regulation',
                title: 'Manage Law/regulation',
                type: 'basic',
                icon: 'gavel',
                link: '/administrator/manage-law-regulation',
                roles: ['SuperAdmin', 'Admin']
            },
            {
                id: 'administrator.manage-certificate',
                title: 'Manage Responsibility',
                type: 'basic',
                icon: 'description',
                link: '/administrator/manage-certificate',
                roles: ['SuperAdmin', 'Admin']
            },
            {
                id: 'administrator.manage-user',
                title: 'Manage User',
                type: 'basic',
                icon: 'manage_accounts',
                link: '/administrator/manage-user',
                roles: ['SuperAdmin', 'Admin']
            },
            {
                id: 'administrator.manage-news-activity',
                title: 'Manage News&Activities',
                type: 'basic',
                icon: 'campaign',
                link: '/administrator/manage-news-activity',
                roles: ['SuperAdmin', 'Admin']
            },
            {
                id: 'administrator.manage-about-us',
                title: 'Manage About Us',
                type: 'basic',
                icon: 'groups',
                link: '/administrator/manage-about-us',
                roles: ['SuperAdmin', 'Admin']
            }

        ]
    },

];

